/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export interface SurveyResponseResponse {
  /** 成功フラグ */
  success: boolean
}
